import React, { useState } from 'react'
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { useDispatch } from 'react-redux';
import { toast } from "react-toastify";
import { toast_error, toast_success } from '../../config/Constant';
import { setLoader } from '../../slice/commonSlice';
import { createJobReview } from '../../services/auth.service';
import ReactStars from "react-rating-stars-component";

const ReviewModal = (props) => {

  const [description, setDescription] = useState('');
  const [rating, setRating] = useState('');
  const dispatch = useDispatch();

  const handleSubmit = async (e) => {
    e.preventDefault();
    let payload = {
      "userType": props?.userType || "provider",
      "reviewGivenTo": props.job?.userId?._id,
      "userRating": rating?.toString(),
      "userReview": description,
      "serviceId": props.job?.serviceId?._id,
      "jobId": props.job?._id
    }

    console.table('>>>>', payload)

    await dispatch(setLoader(true));
    try {
      const response = await createJobReview(payload);
      toast.success(response?.data?.message, toast_success);
      props.handleReviewSuccess();
      await dispatch(setLoader(false));
      props.setReviewModal(false)
    } catch (error) {
      toast.error(error?.data?.message, toast_error)
      await dispatch(setLoader(false));
      props.setReviewModal(false)
      console.error("Error data:", error);
    }
  };

  const ratingChanged = (newRating) => {
    setRating(newRating);
  };


  return (
    <>
      <Modal
        size="sm"
        show={props.reviewModal}
        onHide={() => props.setReviewModal(false)}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
        </Modal.Header>
        <Modal.Body className='pt-0'>
          <h2 className='modal-title text-center'>Share Review</h2>
          <Form className='modal-form-wrapper' enctype="multipart/form-data" onSubmit={(e) => handleSubmit(e)}>
            <Form.Group className="mb-2">
            <ReactStars
              count={5}
              onChange={ratingChanged}
              size={24}
              emptyIcon={<i className="far fa-star"></i>}
              halfIcon={<i className="fa fa-star-half-alt"></i>}
              fullIcon={<i className="fa fa-star"></i>}
              activeColor="#ffd700"
            />
            </Form.Group>
            <Form.Group className="mb-4" controlId="describe">
            <Form.Label>Description</Form.Label>
              <Form.Control
                as="textarea"
                value={description}
                placeholder="Description"
                name="description"
                onChange={(e) => setDescription(e.target.value)}
                rows={3}
              />
            </Form.Group>
            <Form.Group className='mb-4'>
              <div className="d-grid">
                <Button type="submit" variant="primary" size="lg" onClick={handleSubmit}>
                Share Review
                </Button>
              </div>
            </Form.Group>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  )
}

export default ReviewModal
